import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=5f89b2d5&"
import script from "./IconMenu.vue?vue&type=script&lang=js&"
export * from "./IconMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports